import { dayjs } from '@playbooks/utils';

import markdownit from 'markdown-it';

export const AtomFeedDecorator = () => ({
	id: `${process.env.NEXT_PUBLIC_WEB_CLIENT}/blog`,
	title: 'Playbooks Blog',
	description: 'All the company news and resources that are fit to print to one place.',
	link: `${process.env.NEXT_PUBLIC_WEB_CLIENT}/atom`,
	language: 'en',
	image: `${process.env.NEXT_PUBLIC_WEB_CLIENT}/seo/playbooks-cover.jpg`,
	favicon: `${process.env.NEXT_PUBLIC_WEB_CLIENT}/branding/playbooks-favicon.png`,
	copyright: `${new Date().getFullYear()} © Playbooks, Inc`,
	feedLinks: { atom: `${process.env.NEXT_PUBLIC_WEB_CLIENT}/atom` },
	author: {
		name: 'Playbooks HQ',
		email: 'press@playbooks.ai',
		link: `${process.env.NEXT_PUBLIC_WEB_CLIENT}/blog`,
	},
});

export const AtomArticleDecorator = data => {
	const md = markdownit();

	return {
		id: data.uuid,
		image: data.cover,
		title: data.title,
		link: data.webUrl,
		description: data.subtitle,
		content: md.render(data.content),
		category: [
			{
				name: data.tag?.name,
				term: data.tag?.uuid,
			},
		],
		date: dayjs(data.publishDate).toDate(),
	};
};

export const AtomAuthorDecorator = data => ({
	name: data.name,
	email: data.email,
	link: data.webUrl,
});

export const AtomContributorDecorator = data => ({
	name: data.name,
	email: data.email,
	link: data.webUrl,
});
